import { CircularProgress, Typography } from "@material-ui/core";
import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    circularProgress: {
      marginRight: "10px"
    },
    prepareTreeMessage: {
      top: 20,
      left: 15,
      height: 20,
      width: 400,
      display: "flex",
      justifyContent: "flexStart",
      alignItems: "center"
    }
  })
);

export const PrepareTreeProgress = () => {
  const i18n = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.prepareTreeMessage}>
      <CircularProgress
        size={16}
        color={"inherit"}
        className={classes.circularProgress}
      />
      <Typography variant={"subtitle1"}>
        {i18n.t("hns:tree:preparing").toUpperCase()}
      </Typography>
    </div>
  );
};
